/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_Time_SecondsInputs */



/**
* | output |
* | --- |
* | "Time SS" |
*
* @param {Markers_Export_Time_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_time_seconds = /** @type {((inputs?: Markers_Export_Time_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_Time_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Temps SS")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeit SS")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo SS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время СС")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo SS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间SS")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時間SS")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय एसएस")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tempo SS")
	return /** @type {LocalizedString} */ ("Time SS")
});